import { labelUsers } from "_constants";
import { ButtonAddUser } from "components/buttons";
import { HeaderMainContent, HeaderTableContent } from "components/shared";
import { InputSearchUsers, InputUserRole, UsersTable } from "./components";

export const UsersPage = () => {
  return (
    <>
      <HeaderMainContent child={<ButtonAddUser />} label={labelUsers} />
      <HeaderTableContent
        child={
          <>
            <InputSearchUsers />
            <InputUserRole />
          </>
        }
      />
      <UsersTable />
    </>
  );
};
